import { AuthScene } from './AuthScene';

export function SignInPage() {
  return <AuthScene mode="signin" />;
}
